import { render, staticRenderFns } from "./MetricasDoCliente.vue?vue&type=template&id=50d201b9&scoped=true&"
import script from "./MetricasDoCliente.vue?vue&type=script&lang=ts&"
export * from "./MetricasDoCliente.vue?vue&type=script&lang=ts&"
import style0 from "./MetricasDoCliente.vue?vue&type=style&index=0&id=50d201b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d201b9",
  null
  
)

export default component.exports